// El botón de exportar de la lista de casos Cofidis pide a react-admin
// `getList('cofidisCases')`, y react-admin-firebase lee para eso la colección
// entera en Firestore (2.791 lecturas por clic el 18/09) y luego ordena, filtra
// y corta la página en memoria (dist/src/providers/queries/GetList.js).
//
// Aquí la colección sale del VPS y el resto se hace con las MISMAS funciones
// de la librería, así que el CSV no cambia en nada: ni el orden, ni el tope de
// 1.000 filas de ExportButton, ni cómo filtra (por ejemplo, con el buscador
// `q` puesto no sale ninguna fila, porque los casos no tienen un campo `q`).
// Si el VPS no contesta, la librería lee Firestore como siempre.
import { filterArray, sortArray } from 'react-admin-firebase/dist/src/misc/arrayHelpers';
import { applyRefDocs, translateDocFromFirestore } from 'react-admin-firebase/dist/src/misc/translate-from-firestore';
import { descargarCasos, espejoConfigurado } from '../shared/vpsMirror';

// Lo que hace GetList con `softDelete: false` y sin `relativeFilePaths`
// (App.js): cada documento como parseFireStoreDocument, luego orden, filtro y
// página.
export async function listaDeCasos(params, filas) {
  const data = filas.map(({ id, datos }) => {
    const r = translateDocFromFirestore(datos);
    return { id, ...applyRefDocs(r.parsedDoc, r.refdocs) };
  });
  if (params.sort != null) sortArray(data, params.sort.field, params.sort.order === 'ASC' ? 'asc' : 'desc');
  const filtradas = filterArray(data, params.filter || {});
  const inicio = (params.pagination.page - 1) * params.pagination.perPage;
  return { data: filtradas.slice(inicio, inicio + params.pagination.perPage), total: filtradas.length };
}

export function conCasosDelEspejo(dataProvider) {
  if (!espejoConfigurado()) return dataProvider;
  return {
    ...dataProvider,
    getList: async (resource, params) => {
      // Con una consulta propia de Firestore, la librería (no se usa hoy).
      if (resource !== 'cofidisCases' || params?.filter?.collectionQuery) return dataProvider.getList(resource, params);
      let filas;
      try {
        filas = await descargarCasos();
      } catch (error) {
        return dataProvider.getList(resource, params);
      }
      return listaDeCasos(params, filas);
    },
  };
}
